<template>
    <button class="hover cancel-icon export-box" :class="{'exporting':percent>0}"  @click="clickFun">
       <template v-if="percent>0">
            <span>导出中</span><span class="percent">{{percent}}%</span>
            <div class="line">
                <div class="progress-bar" :style="{width: percent + '%'}"></div>
            </div>
       </template>
       <template v-else>
        <!-- <local-svg iconClass="export" class="icon"></local-svg><span>{{text}}</span> -->
         <slot></slot>
       </template>
    </button>
</template>

<script>
export default {
    name: 'ExportBox',
    props: {
        percent:{
            type: Number,
            default: 0
        },
    },
    data() {
        return {
           text:'导出'
        };
    },
    methods: {
        clickFun() {
            this.$emit('click');
        }
    }
};
</script>

<style lang="scss" scoped>
.export-box{
    white-space: nowrap;
    position: relative;
    &.exporting{
        background: #F1F2F6;
        border-radius: 4px;
        border: 1px solid #E2E7EE!important;
        color: #4D535C!important;
    }
    .percent{
        margin-left: 4px;
        color: #1D78FE;
        display: inline-block;
    }

    .line{
        position: absolute;
        left: 0;
        bottom: 0;
        right: 0;
        height:2px;
        border-radius: 1px;
        background: #E5EBF4;
        overflow: hidden;
        .progress-bar{
            height: 100%;
            border-radius: 1px;
            background: #1D78FE;
            transition: width 0.3s ease-in-out;
        }
    }
}
</style>